/**
 * Allergies Service
 * Patient allergy tracking and management API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { CapacitorHttp } from '@capacitor/core';
import { HttpParameterCodec, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import Session from 'supertokens-web-js/recipe/session';
import { AuthStrategy } from '@generator-strategies/auth-strategy';
import { TenantStrategy } from '@generator-strategies/tenant-strategy';

// @ts-ignore
import { AllergiesControllerCheckExposure200Response } from '../model/allergiesControllerCheckExposure200Response';
// @ts-ignore
import { AllergiesControllerCreate200Response } from '../model/allergiesControllerCreate200Response';
// @ts-ignore
import { AllergiesControllerList200Response } from '../model/allergiesControllerList200Response';
// @ts-ignore
import { CheckExposureRequestDto } from '../model/checkExposureRequestDto';
// @ts-ignore
import { CreateAllergyRequestDto } from '../model/createAllergyRequestDto';
// @ts-ignore
import { HistoryEntryResponseDto } from '../model/historyEntryResponseDto';
// @ts-ignore
import { UpdateAllergyRequestDto } from '../model/updateAllergyRequestDto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

@Injectable({
  providedIn: 'root'
})
export class AllergiesService {
  protected basePath = 'http://localhost';
  public defaultHeaders: any = {};
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    @Optional()@Inject(BASE_PATH) basePath: string|string[],
    @Optional() configuration: Configuration,
    @Optional() private readonly authStrategy: AuthStrategy,
    @Optional() private readonly tenantStrategy: TenantStrategy,
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      if (Array.isArray(basePath) && basePath.length > 0) {
        basePath = basePath[0];
      }

      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }


  /**
   * Check for allergen exposure
   * Real-time allergen exposure checking with cross-reactivity validation (&lt;100ms response time)
   * @param checkExposureRequestDto 
   */
  public async allergiesControllerCheckExposure(checkExposureRequestDto: CheckExposureRequestDto, ): Promise<AllergiesControllerCheckExposure200Response> {
    if (checkExposureRequestDto === null || checkExposureRequestDto === undefined) {
      throw new Error('Required parameter checkExposureRequestDto was null or undefined when calling allergiesControllerCheckExposure.');
    }

    const localVarHeaders = this.defaultHeaders;

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/forthbridge-allergy/allergies/check-exposure`,
        data: checkExposureRequestDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Create an allergy
   * @param createAllergyRequestDto 
   */
  public async allergiesControllerCreate(createAllergyRequestDto: CreateAllergyRequestDto, ): Promise<AllergiesControllerCreate200Response> {
    if (createAllergyRequestDto === null || createAllergyRequestDto === undefined) {
      throw new Error('Required parameter createAllergyRequestDto was null or undefined when calling allergiesControllerCreate.');
    }

    const localVarHeaders = this.defaultHeaders;

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/forthbridge-allergy/allergies`,
        data: createAllergyRequestDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Delete allergy
   * @param id 
   * @param reason 
   */
  public async allergiesControllerDelete(id: string, reason: string, ): Promise<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling allergiesControllerDelete.');
    }
    if (reason === null || reason === undefined) {
      throw new Error('Required parameter reason was null or undefined when calling allergiesControllerDelete.');
    }

    const localVarQueryParameters = new URLSearchParams();
    if (reason !== undefined && reason !== null) {
      localVarQueryParameters.append('reason', String(reason));
    }

    const localVarHeaders = this.defaultHeaders;

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const queryString = localVarQueryParameters.toString();
    const urlWithParams = queryString ? `${this.configuration.basePath}/api/forthbridge-allergy/allergies/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}?${queryString}` : `${this.configuration.basePath}/api/forthbridge-allergy/allergies/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
    const response = await CapacitorHttp.delete({
      url: urlWithParams,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Get allergy by ID
   * @param id 
   * @param expand Fields to expand in the response
   */
  public async allergiesControllerGetById(id: string, expand?: Array<'allergy-type' | 'verification-status' | 'criticality' | 'reaction-severity' | 'reaction-manifestation'>, ): Promise<AllergiesControllerCreate200Response> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling allergiesControllerGetById.');
    }

    const localVarQueryParameters = new URLSearchParams();
      if (expand) {
        expand.forEach((element) => {
          localVarQueryParameters.append('expand', String(element));
        });
    }

    const localVarHeaders = this.defaultHeaders;

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const queryString = localVarQueryParameters.toString();
    const urlWithParams = queryString ? `${this.configuration.basePath}/api/forthbridge-allergy/allergies/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}?${queryString}` : `${this.configuration.basePath}/api/forthbridge-allergy/allergies/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
    const response = await CapacitorHttp.get({
      url: urlWithParams,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Get change history for an allergy
   * @param id 
   */
  public async allergiesControllerGetHistory(id: string, ): Promise<Array<HistoryEntryResponseDto>> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling allergiesControllerGetHistory.');
    }

    const localVarHeaders = this.defaultHeaders;

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.get({
      url: `${this.configuration.basePath}/api/forthbridge-allergy/allergies/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/history`,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * List allergies
   * @param patientId Filter by patient identifier
   * @param elementId Filter by element identifier
   * @param status Filter by clinical status value
   * @param criticalityElementIds Filter by criticality element IDs (can specify multiple)
   * @param verificationStatusElementIds Filter by verification status element IDs (can specify multiple)
   * @param limit Number of items to return
   * @param offset Number of items to skip
   * @param expand Fields to expand in the response
   */
  public async allergiesControllerList(patientId?: string, elementId?: string, status?: 'active' | 'inactive' | 'resolved', criticalityElementIds?: string, verificationStatusElementIds?: string, limit?: number, offset?: number, expand?: Array<'allergy-type' | 'verification-status' | 'criticality' | 'reaction-severity' | 'reaction-manifestation'>, ): Promise<AllergiesControllerList200Response> {

    const localVarQueryParameters = new URLSearchParams();
    if (patientId !== undefined && patientId !== null) {
      localVarQueryParameters.append('patientId', String(patientId));
    }
    if (elementId !== undefined && elementId !== null) {
      localVarQueryParameters.append('elementId', String(elementId));
    }
    if (status !== undefined && status !== null) {
      localVarQueryParameters.append('status', String(status));
    }
    if (criticalityElementIds !== undefined && criticalityElementIds !== null) {
      localVarQueryParameters.append('criticalityElementIds', String(criticalityElementIds));
    }
    if (verificationStatusElementIds !== undefined && verificationStatusElementIds !== null) {
      localVarQueryParameters.append('verificationStatusElementIds', String(verificationStatusElementIds));
    }
    if (limit !== undefined && limit !== null) {
      localVarQueryParameters.append('limit', String(limit));
    }
    if (offset !== undefined && offset !== null) {
      localVarQueryParameters.append('offset', String(offset));
    }
      if (expand) {
        expand.forEach((element) => {
          localVarQueryParameters.append('expand', String(element));
        });
    }

    const localVarHeaders = this.defaultHeaders;

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const queryString = localVarQueryParameters.toString();
    const urlWithParams = queryString ? `${this.configuration.basePath}/api/forthbridge-allergy/allergies?${queryString}` : `${this.configuration.basePath}/api/forthbridge-allergy/allergies`;
    const response = await CapacitorHttp.get({
      url: urlWithParams,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Update allergy
   * @param id 
   * @param updateAllergyRequestDto 
   */
  public async allergiesControllerUpdate(id: string, updateAllergyRequestDto: UpdateAllergyRequestDto, ): Promise<AllergiesControllerCreate200Response> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling allergiesControllerUpdate.');
    }
    if (updateAllergyRequestDto === null || updateAllergyRequestDto === undefined) {
      throw new Error('Required parameter updateAllergyRequestDto was null or undefined when calling allergiesControllerUpdate.');
    }

    const localVarHeaders = this.defaultHeaders;

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.put({
      url: `${this.configuration.basePath}/api/forthbridge-allergy/allergies/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`,
        data: updateAllergyRequestDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
}
